export const MAX_DISPLAYED_RELATED_EVENTS = 10;
export const MAX_RELATED_EVENTS_RETURNED_COUNT = 30;
